var $b732722345336843$exports = {};
$b732722345336843$exports = {
    "actions": `Acties`,
    "hideButtonLabel": `Minder weergeven`,
    "noTags": `Geen`,
    "showAllButtonLabel": (args, formatter)=>`Alles tonen (${formatter.number(args.tagCount)})`
};


export {$b732722345336843$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
